import ScrollBooster from 'scrollbooster';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import modalScript from './_modal.js';

export default function () {
  //set viewport width
  recommendContainerResize();
  opnerWhenResize();
  new ScrollBooster({
    viewport: document.querySelector('.title-list-container'),
    scrollMode: 'native',
    direction: 'horizontal',
    emulateScroll: true,
  });
  $(window).on("resize", recommendContainerResize);
  $(window).on("resize", opnerWhenResize);

  // 詳細オープン
  $(".btn-detail-opner").on("click", function(e){
    if($(this).hasClass('open')){
      $(".item-detail-body .item-detail-body-inner").removeClass('open');
      $(this).removeClass('open');
      setTimeout( function(){
        $(".item-detail-body-inner p").removeClass('show');
      },700);
    } else {
      $(".item-detail-body .item-detail-body-inner").addClass('open');
      $(this).addClass('open');
      $(".item-detail-body-inner p").addClass('show');
    }
  });
  $(".cover").on("click", function(){
    $(".item-detail-modal").addClass('opened');
    modalScript.open();
  })
  $(".item-detail-modal-background").on("click", function(){
    $(".item-detail-modal-close").trigger("click");
  });
  $(".item-detail-modal-close").on("click", function(){
    $(".item-detail-modal").removeClass('opened');
    modalScript.close();
  })
  var count = 20;
  $('#l20').each(function() {
      var thisText = $(this).text();
      var textLength = thisText.length;
        if (textLength > count) {
          var showText = thisText.substring(0, count);
          var insertText = showText += '…';
          $(this).html(insertText);
      };
  });
}

const recommendContainerResize = (e) => {
  if( $(window).innerWidth() < 768 ){
    $('.title-list').css({ width:
      $('.title-list li').length * ($('.title-list li').outerWidth() + 10*2) + 'px' });
  } else {
    $('.title-list').css({ width:
      $('.title-list li').length * ($('.title-list li').outerWidth() + 15*2) + 'px' });
  }
}
const opnerWhenResize = (e) => {
  let _height = 0;
  const _innerElement = $(".item-detail-body-inner").find("p");
  for( let i = 0; i < _innerElement.length; i++ ){
    _height += $(_innerElement[i]).innerHeight();
  }
  if( _height >= 102 ){
    $(".btn-detail-opner").show();
  } else {
    $(".btn-detail-opner").hide();
  }
}
